<template>
  <div class="card border-0 card-with-shadow mb-primary">
    <div class="card-header d-flex align-items-center justify-content-between p-primary bg-transparent">

      <h5 v-show="isContactInfoActive" class="card-title text-muted m-0">
        {{ $t('details_frund_g') }}
      </h5>

      <h5 v-show="!isContactInfoActive" class="card-title text-muted m-0">
        {{ $t("edit_contact_info") }}
      </h5>

      <div>
        <a v-show="!isContactInfoActive" class="text-muted" href="#" @click.prevent="contactInfoClose">
          <app-icon name="x-square" stroke-width="1"/>
        </a>

        <template v-if="personId">

          <a v-show="!isContactInfoActive" class="text-muted" href="#" @click.prevent="contactInfoSync">
            <app-icon name="check-square" stroke-width="1"/>
          </a>

        </template>

        <a v-if="statusCheck && personId" v-show="isContactInfoActive" class="text-muted" href="#"
           @click.prevent="contactInfoEdit">
          <app-icon name="edit" stroke-width="1"/>
        </a>

        <!--          <a v-else v-show="isContactInfoActive" class="text-muted" href="#" @click.prevent="">-->
        <!--            <app-icon name="edit" stroke-width="1"/>-->
        <!--          </a>-->

      </div>
    </div>

    <div class="card-body">

      <template v-if="personId">

        <div v-show="isContactInfoActive">

          <div class="form-group">
            <div class="form-row">
            

              <div v-if="contactInfoData && contactInfoData.flone" class="col-12">

                <div
                  v-for="(floneNumber, index) in contactInfoData.flone"
                  :key="index"
                  class="d-flex justify-content-between">
					
					
					<label class="mb-0 text-muted col-16 d-flex align-items-center">
						<span v-for="item in peopleList" v-if="item.id == floneNumber.value">
							<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
						</span>
					</label>

                  <div class="mb-2">

					  <template v-for="item in peopleList" v-if="item.id == floneNumber.value">
						 
					  	<template v-for="oneitem in typeContactList" v-if="oneitem.id == item.contact_type_id">
							<app-badge
                        :class-name="`badge-sm badge-pill badge-${oneitem.class}`"
                        :label="oneitem.name"/>
					  	</template>
					  </template>
					  
				

                  </div>
                </div>
              </div>
				

             
				 <template v-if="contactInfoData && contactInfoData.flone.length"></template>
                <template v-else>
					<label class="text-muted col-12">
                  <span>{{ $t("no_flone_added") }}</span>
						</label>
                </template>

              
            </div>
          </div>

          

        </div>

        <div v-show="!isContactInfoActive">
          <div class="form-group">
            <div class="form-row">
              

              <div v-if="contactInfoData && contactInfoData.flone" class="col-12">
                <div v-for="(floneNumber, index) in contactInfoData.flone" :key="index"
                     :class="{ 'mb-3': contactInfoData.flone.length > 1 && index !== contactInfoData.flone.length - 1}">

                  <div class="form-row">
                    <div class="col-10">
						<app-input v-model="floneNumber.value"
							           :error-message="$errorMessage(errors, 'size')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
                      <small v-if="errors['flone.'+index+'.value']"
                             class="text-danger">{{ errors['flone.' + index + '.value'][0] }}</small>
                    </div>

                    <div class="col-2 d-flex justify-content-center align-items-center">
                      <a class="text-muted" href="#" @click.prevent="deleteContactInfo('flone', index)">
                        <app-icon name="trash" stroke-width="1" width="20"/>
                      </a>
                    </div>
                  </div>
                </div>
                <a class="font-size-90" href="#" @click.prevent="addMoreContactInfo('flone')">
                  {{ $t("add_more") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <p class="text-muted">{{ $t("not_added_yet") }}</p>
      </template>

    </div>
  </div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";

export default {
  name: "DetailsContactInfo",
  mixins: [FormMixin],
  props: {
    contactInfoData: {
      required: true,
    },
    personId:{
      default: null,
      required: false
    },
    contactInfoSyncUrl: {
      type: String,
      required: true
    },
    statusCheck: {
      default: true,
      required: false
    }
  },
  data() {
    return {
      isContactInfoActive: true,
      errors: {}
    };
  },
  computed: {
    typeList() {
      return this.$store.getters.getPhoneEmailType;
    },
	  peopleList() {
			return this.$store.getters.getPerson
		},
	  typeContactList() {
			return this.$store.getters.contentType
		},
  },
  methods: {
    generateValidationMessage(value, name) {
      let message = value.split(" ");
      message[1] = name;
      return message.join(' ');
    },
    addMoreContactInfo(type) {

      if (type === "phone") {
        this.contactInfoData.phone.push({
          phone: {
            value: "",
            type_id: "",
          },
        });
      }else if (type === "flone") {
        this.contactInfoData.flone.push({
          flone: {
            value: "",
            type_id: "",
          },
        });
      } else {

        this.contactInfoData.email.push({
          email: {
            value: "",
            type_id: "",
          },
        });
      }
    },
    contactInfoSync() {
      let phoneFlatArray = this.contactInfoData.phone.map((data) => {
        return {
          value: data.value,
          type_id: data.type_id,
        };
      });
      let floneFlatArray = this.contactInfoData.flone.map((data) => {
        return {
          value: data.value,
          type_id: data.type_id,
        };
      });

      let emailFlatArray = this.contactInfoData.email.map((data) => {
        return {
          value: data.value,
          type_id: data.type_id,
        };
      });

      this.submitFromFixin('post', this.contactInfoSyncUrl, {
        phone: phoneFlatArray,
        flone: floneFlatArray,
        email: emailFlatArray
      })
    },

    afterError(response) {
      this.errors = response.data.errors;
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.isContactInfoActive = true;
      this.$emit("update-request");
    },
    deleteContactInfo(type, index) {
      if (type === "phone") {
        this.contactInfoData.phone.splice(index, 1);
      }else if (type === "flone") {
        this.contactInfoData.flone.splice(index, 1);
      } else {
        this.contactInfoData.email.splice(index, 1);
      }
    },

    contactInfoClose() {
      this.isContactInfoActive = true;
    },
    contactInfoEdit() {
      this.isContactInfoActive = false;
    },

  },
  created() {
    this.$store.dispatch("getPhoneEmailType");
	 
  },
};
</script>

